import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import DashboardOverviewPage from "./pages/DashboardOverviewPage";
import CoursesPage from "./pages/CoursesPage";
import EventsPage from "./pages/EventsPage";
import EventDetailPage from "./pages/EventDetailPage";
import UsersPage from "./pages/UsersPage";
import ParentsPage from "./pages/ParentsPage";
import AuditLogPage from "./pages/AuditLogPage";
import ConfirmPage from "./pages/ConfirmPage";

export default function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/confirm/:token" element={<ConfirmPage />} />
      <Route path="/dashboard" element={<DashboardOverviewPage />} />
      <Route path="/courses" element={<CoursesPage />} />
      <Route path="/events" element={<EventsPage />} />
      <Route path="/events/:eventId" element={<EventDetailPage />} />
      <Route path="/users" element={<UsersPage />} />
      <Route path="/parents" element={<ParentsPage />} />
      <Route path="/audit-log" element={<AuditLogPage />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
